import "./Footer.css";
const PDF_URL = "https://atlantykron.viorelspinu.com/Atlantikron_2026_Primul_tau_agent_AI.pdf";

const Footer = ({ showAskAnythingDialog }) => {
    const handleLinkClick = (event) => {
        event.preventDefault();
        showAskAnythingDialog();
    };
    return (<footer className="lp-footer">
        <div className="lp-footer__inner">
            <div>
                <p className="lp-footer__brand">Viorel Spînu</p>
                <p className="lp-footer__line">Inginer. Explic AI-ul pe românește.</p>
                <p className="lp-footer__copy">&copy; {new Date().getFullYear()} Viorel Spînu</p>
            </div>
            <nav className="lp-footer__links" aria-label="Linkuri utile">
                <a href="/#/confidentiality">Politica de confidențialitate</a>
                <a href="/#/terms">Termeni și condiții</a>
                <button type="button" className="lp-footer__btn" onClick={handleLinkClick}>Contact</button>
                <a href={PDF_URL} target="_blank" rel="noopener noreferrer">Primul tău agent AI (PDF)</a>
            </nav>
        </div>
    </footer>);
}

export default Footer;
